module.exports = __webpack_public_path__ + "static/images/containers/PostbattleScreen/components/FortBattleSeries/images/arrow-attack-short.ecbcc89f.png";


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/components/FortBattleSeries/images/arrow-attack-short.png
// module id = 3216
// module chunks = 11